import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
export const projectsMappingDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.editMapping',
        popover: {
          title: 'Edit Project Mapping',
          description:
            'Use this option to modify the mapping between projects and their corresponding resources. Ensure that all changes reflect the current project requirements.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.deleteMapping',
        popover: {
          title: 'Delete Project Mapping',
          description:
            'This action allows you to remove an existing project mapping. Please confirm that the mapping is no longer needed before deletion, as this action is irreversible.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.projectsMappingMainTable',
        popover: {
          title: 'Projects Mapping Overview',
          description:
            'This table shows all current project mappings, allowing you to view, edit, or delete mappings as needed. It is essential for managing the relationships between projects and resources.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
export default projectsMappingDriverObj;
